"use strict";

module.exports = {
    "i-services": {
        "404": "404",
        "adresa": "Адреслар",
        "advertising": "Реклама",
        "afisha": "Афиша",
        "all": "Барлык сервислар",
        "api": "API",
        "appmetrica": "AppMetrica",
        "appsearch": "Кушымталар",
        "audience": "Аудитории",
        "auto": "Авто",
        "autoru": "auto.ru",
        "avia": "Авиабилетлар",
        "aziada": "Азиада",
        "ba": "Баян",
        "backapv": "Партнер Я.Карт",
        "balance": "Баланс",
        "bar": "Бар",
        "bar-ie": "Бар для ИЕ",
        "bar-ie9": "Бар для ИЕ9",
        "bayan": "Яндексның баннерлары",
        "blogs": "Блоглар",
        "books": "Китаплар",
        "browser": "Браузер",
        "calendar": "Календарь",
        "captcha": "ой...",
        "catalogwdgt": "Каталог виджетов",
        "chrome": "Хром с поиском Яндекса",
        "city": "Шәһәрләр",
        "cityday": "Шәһәр көне",
        "clickhouse": "ClickHouse",
        "collection": "Коллекция",
        "company": "Компания",
        "contest": "Contest",
        "delivery": "Доставка",
        "desktop": "Персональный поиск",
        "direct": "Директ",
        "direct.market": "Маркет",
        "disk": "Диск",
        "display": "Дисплей",
        "ege": "ЕГЭ",
        "expert": "Эксперт",
        "feedback": "Кире элемтә",
        "feedback2": "Кире элемтә",
        "ff": "ФФ с поиском Яндекса",
        "fotki": "Фотолар",
        "fresh": "Иң соңгы",
        "games": "Уенчыклар",
        "geocontext": "Геоконтекст",
        "goroda": "Шәһәрләр",
        "help": "Ярдәм",
        "i": "Мои сервисы",
        "ie": "ИЕ с поиском Яндекса",
        "images": "Рәсемнәр",
        "images-com": "Рәсемнәр",
        "interests": "Кызыксынулар",
        "internet": "Интернет",
        "kassa": "Касса",
        "keyboard": "Клавиатура",
        "kraski": "Буяулар",
        "kuda": "Болар бөтенеседә кайда баралар",
        "large": "Яндекс для слабовидящих",
        "legal": "Правовые документы",
        "lenta": "Тасма",
        "libra": "Библиотека",
        "literacy": "Неделя борьбы за грамотность",
        "local": "Локаль челтәр",
        "lost": "Хатирәләр",
        "love": "Үзара тартылу көне — 13 аувгустt",
        "mail": "Почта",
        "maps": "Карталар",
        "maps-wiki": "Народная карта",
        "market": "Маркет",
        "market.advertising": "Маркет",
        "master": "Мастер",
        "metrika": "Метрика",
        "metro": "Метро",
        "mobile": "Мобиль",
        "moikrug": "Мой Круг",
        "money": "Акча",
        "museums": "Тарихи-мәдәни мирасы көннәре",
        "music": "Музыка",
        "music-partner": "Музыка: статистикасы",
        "nahodki": "Табылдыкларым",
        "nano": "Нано",
        "newhire": "Наниматор",
        "news": "Яңалыклар",
        "notifications": "Нотификация панеле",
        "oauth": "OAuth",
        "online": "Онлайн",
        "openid": "OpenID",
        "opera": "Opera Software",
        "opinion": "Өземтәләр",
        "partners": "Рекламная сеть",
        "partnersearch": "Партнерлар өчен эзләү",
        "passport": "Паспорт",
        "pdd": "Домен өчен почта",
        "peoplesearch": "Кешеләр",
        "perevod": "Тәрҗемәче",
        "probki": "Тыгынлыклар",
        "pulse": "блоги: пульс",
        "punto": "Punto switcher",
        "pvo": "Җаваплар",
        "rabota": "Эш",
        "radar": "Радар",
        "ramazan": "",
        "rasp": "Расписаниеләр",
        "realty": "Күчемсез милек",
        "referats": "Рефератлар",
        "rk": "Сораулар бар?",
        "root": "Unix администраторлары өчен Яндекс.Олимпиадасы ",
        "school": "Школьная морда",
        "search": "Эзләү",
        "server": "Сервер",
        "shtrafi": "Штрафлар",
        "site": "Сайт өчен эзләү",
        "slovari": "Сүзлекләр",
        "so": "Самооборона",
        "social": "Социализм",
        "soft": "Программалар",
        "sport": "Спорт",
        "sprav": "Белешмәлек",
        "start": "Баш бит",
        "stat": "Статистика",
        "subs": "Язылулар",
        "taxi": "Такси",
        "telephony": "Телефония",
        "terms": "Сөйләүлек",
        "tests": "Тестлар һәм сорашулар",
        "tickets": "Билетлар",
        "time": "Яндекс.Вакыт",
        "toloka": "Яндекс.Толока",
        "toster": "Тостлар",
        "translate": "Тәрҗемәче",
        "tune": "Рәтләүләр",
        "tv": "ТВ",
        "uslugi": "Услуги",
        "video": "Видео",
        "video-com": "Видео",
        "vno": "ВНО",
        "wdgt": "Виджетлар",
        "weather": "Һава торышы",
        "webmaster": "Вебмастер",
        "webmaster-api": "API Вебмастера",
        "widgets": "Виджетлар",
        "wordstat": "Статистика",
        "wow": "Я.ру",
        "www": "Эзләү",
        "xmlsearch": "XML",
        "yaca": "Каталог",
        "yamb": "Медийные баннеры",
        "zakladki": "Кыстыргычлар"
    }
};